import React, { useState } from "react";
import { FiPlus, FiX } from "react-icons/fi";
import img1 from "../../../Assets/propertyPage/Comprehensivebackground.png";
// import Banner from "../FAQ/Banner";
import faq from "../../../Assets/UserSide/FAQ.png";
import Banner from "../abouts/Banner";
const FAQ = () => {
  const [openRule, setOpenRule] = useState(null);

  const rules = [
    {
      title:
        "What is Yostel and how is it different from a regular PG or hostel in Bhubaneswar?",
      content:
        "Yostel is a professionally managed student housing and co-living space in Bhubaneswar. Unlike traditional PGs or hostels, we offer fully furnished rooms, a strong community, 24/7 security, modern amenities, and a vibrant environment where you feel truly at home. Book a free tour today and experience Yostel for yourself!",
      listItems: [],
    },
    {
      title: " Where is Yostel located in Bhubaneswar?",
      content:
        "Yostel is strategically located near top colleges, universities, and major workplaces in Bhubaneswar, ensuring easy access and reduced commute time. 📍 Want to know the nearest Yostel property to your institution? [Contact us here!]",
      listItems: [],
    },
    {
      title: "What types of accommodation does Yostel offer?",
      content: "We provide a range of living options:",
      listItems: [
        "Modern Student Housing",
        "Co-Living for Young Professionals",
        "Fully Managed Apartments",
      ],
    },
    {
      title: "What facilities are included in the rent at Yostel?",
      content: "Our all-inclusive rent covers:",
      listItems: [
        "Fully furnished rooms",
        "Housekeeping & laundry services",
        "High-speed Wi-Fi",
        "Nutritious meals",
        "24/7 security",
        "Study lounges and recreational spaces",
      ],
    },
    {
      title: "Is there a security system in place at Yostel?",
      content:
        "Yes, your safety is our top priority. Yostel offers 24/7 CCTV surveillance, biometric access control, on-site security personnel, and emergency assistance to ensure a safe and worry-free living experience.",
      listItems: [],
    },
    {
      title: " What are the food options available at Yostel?",
      content:
        "At Yostel, we serve fresh, home-style, nutritious meals with a local touch. Our dining experience ensures you enjoy tasty and hygienic food daily — just like home.",
      listItems: [],
    },
    {
      title: "Can I visit and see the property before booking?",
      content:
        "Absolutely! We highly recommend booking a personal or virtual tour before finalizing your stay. This way, you can experience the Yostel vibe firsthand.",
      listItems: [
        "Fully furnished roomsg",
        "Housekeeping & laundry services",
        "High-speed Wi-Fi",
        "Nutritious meals",
        "24/7 security",
        "Study lounges and recreational spaces",
      ],
    },
    {
      title: "How do I book a room at Yostel?",
      content: "Booking a room is simple:",
      listItems: [
        "Fill out your details online",
        "Schedule a visit or virtual tour",
        "Choose your room",
        "Complete the easy booking process",
      ],
    },

    {
      title: "Is Yostel suitable for working professionals too?",
      content:
        "Yes! Yostel offers co-living spaces designed for young working professionals who want modern amenities, peace of mind, and a thriving community to grow with.",
      listItems: [],
    },

    {
      title: "What happens if my plans change after booking?",
      content:
        "We understand things can change. Yostel offers flexible cancellation policies for early-stage bookings. Our team is here to assist you with a smooth process.",
      listItems: [],
    },
  ];

  return (
    <div>
      <Banner title="FAQs" />
      <div className="flex flex-col-reverse lg:flex-row gap-8 sm:px-16 p-6 items-center">
        {/* Housing Rules Section */}
        <div className="xl:w-[80%] lg:w-[70%] w-full ">
          <h2 className="text-2xl font-semibold mb-4">
            Frequently Asked Questions
          </h2>
          <div className="space-y-3 ">
            {rules.map((rule, index) => (
              <div
                key={index}
                className="border rounded-lg p-4 shadow-sm bg-white"
              >
                <div
                  className="flex justify-between items-center cursor-pointer "
                  onClick={() => setOpenRule(openRule === index ? null : index)}
                >
                  <h3 className="text-gray-800 font-medium">{rule.title}</h3>
                  {openRule === index ? (
                    <FiX className="text-gray-500" />
                  ) : (
                    <FiPlus className="text-gray-500" />
                  )}
                </div>
                {openRule === index && rule.content && (
                  <div>
                    <p className="text-gray-600 text-sm leading-relaxed mt-2">
                      {rule.content}
                    </p>
                    <ul className="flex flex-col text-sm  gap-1 list-disc pl-5">
                      {rule.listItems.length > 0 &&
                        rule.listItems.map((item, index) => (
                          <li className="text-gray-600 mt-2 ">{item}</li>
                        ))}
                    </ul>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>

        {/* Promo Section */}
        {/* <div
          className="xl:w-[20%] lg:w-[30%] sm:w-[50%] w-full text-white p-6 rounded-lg bg-cover bg-center"
          style={{ backgroundImage: `url(${img1})` }}
        >
          <h3 className="text-2xl tracking-wide font-semibold">
            Stay Longer, Save More
          </h3>
          <p className="italic text-red-300 mt-1">
            It is simple – the longer you stay, the more you save
          </p>
          <div className="mt-4 space-y-2 text-sm">
            <p>
              Save up to 20% off the nightly rate on stays between 7-14 nights
            </p>
            <p>
              Save up to 30% off the nightly rate on stays between 14-29 nights
            </p>
          </div>
          <button className="mt-4 bg-white text-blue-700 px-4 py-2 rounded-lg font-medium">
            Call Now
          </button>
        </div> */}

        <img src={faq} alt="" className="h-fit" />
      </div>
    </div>
  );
};

export default FAQ;
